module.exports = __webpack_public_path__ + "img/call.0e980f06.png";